import { Theme } from '@emotion/react';
import { SxProps } from '@mui/material';
import { OpenSansFontWeights } from 'shared/custom/constants/commonConstants';

export const storeLocatorHoursSX: SxProps = {
	marginTop: '10px',
	marginBottom: '10px',
};

export const storeLocatorHoursTitleSX: SxProps = {
	fontWeight: OpenSansFontWeights.semibold,
};

export const storeLocatorHoursContentSX = (isToday: boolean): SxProps<Theme> => ({
	display: 'flex',
	justifyContent: 'space-between',
	fontSize: '12px',
	...(isToday && { fontWeight: OpenSansFontWeights.semibold }),
});
